const ALLOWED_YOUTUBE_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'music.youtube.com',
  'youtu.be',
  'www.youtu.be',
]);

export function isAllowedYoutubeUrl(value: string): boolean {
  const match = value.match(/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/([^/?#]+)/);
  if (!match) return false;

  const authority = match[1];
  if (!authority) return false;

  const normalizedAuthority = authority.replace(/^[^@]*@/, '');
  const hostname = normalizedAuthority.startsWith('[')
    ? normalizedAuthority.slice(1, normalizedAuthority.indexOf(']'))
    : normalizedAuthority.split(':')[0];
  if (!hostname) return false;

  return ALLOWED_YOUTUBE_HOSTS.has(hostname.toLowerCase());
}
